import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { StoopMark } from "@/components/icons/StoopMark";

export default function NotFound() {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center bg-background px-6 py-10 text-center"
      style={{ paddingTop: "max(env(safe-area-inset-top, 0px), 32px)" }}
    >
      <StoopMark className="mb-4 h-16 w-16 text-primary" />
      <h1 className="font-display text-4xl font-extrabold text-primary">
        Stoops, there it isn't.
      </h1>
      <p className="mt-3 max-w-sm text-base text-muted-foreground">
        That page wandered off the block. Head back home and we'll get you
        sorted.
      </p>
      <Button asChild size="lg" className="mt-8">
        <Link href="/">Take me home</Link>
      </Button>
    </div>
  );
}
